define([
    'common/ui/view/svg/shape/index',
    'common/ui/view/svg/shape/circle',
    'common/ui/view/svg/shape/ellipse',
    'common/ui/view/svg/shape/rect',
    'common/ui/view/svg/shape/path',
    'common/ui/view/svg/shape/human',
    'common/ui/view/svg/shape/diamond',
//    'common/ui/view/svg/shape/container',
    'backbone'
], function(
    Shape,
    Circle,
    Ellipse,
    Rect,
    Path,
    Human,
    Diamond,
    Container
    ) {

    var functions = [
        'width', 'height', 'offset', 'imageSize', 'imageOffset',
        'setImage', 'createTextArea', 'createTextpath',
        'getBottomRightPoints', 'getBottomLeftPoints',
        'getBorderPoint', 'getBorderTangent'
    ];

    var Container = Shape.extend({
        tagName: 'g',
        initialize: function(params) {
            Container.__super__.initialize.call(this, params);
            this._shapes = _.map(params.shapes, function(shape) {
                var klass = Factory.find(shape.kind);
                return new klass(shape.attr);
            }, this);
            this._delegate = this._shapes[0];
            this._width = this._delegate.width();
            this._height = this._delegate.height();
            this._offset = this._delegate.offset();

            _.each(functions, _.bind(function(f) {
                this[f] = _.bind(this._delegate[f], this._delegate);
            }, this));
        },

        render: function() {
            _.each(this._shapes, _.bind(function(shape) {
                this.$el.append(shape.render().el);
            }, this));
            return this;
        }
    }, {
        type: 'container'
    });

    var shapes = {
        circle: Circle,
        ellipse: Ellipse,
        rect: Rect,
        path: Path,
        human: Human,
        diamond: Diamond,
        container: Container
    };

    var Factory = {
        find: function(type) {
            var klass = shapes[type];
            if(!klass) {
                throw 'No such Shape: ' + type;
            }
            return klass;
        },
        create: function(type, params) {
            var klass = shapes[type];
            if(!klass) {
                throw 'No such Shape: ' + type;
            }
            return new klass(params);
        }
    };
    return Factory;
});



// WEBPACK FOOTER //
// ./common/ui/view/svg/shape/factory.js